var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgInsertImage = function SvgInsertImage(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#71717A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3,
    d: "M18.333 8.333H17.5c-1.16 0-1.741 0-2.23.05a9.583 9.583 0 0 0-8.553 8.554 8.26 8.26 0 0 0-.036.554m11.652-9.158v2.5c0 2.334 0 3.5-.453 4.392a4.167 4.167 0 0 1-1.821 1.82c-.892.455-2.059.455-4.392.455H8.334c-.63 0-1.175 0-1.653-.009m11.652-9.158c-.007-1.791-.057-2.78-.453-3.558a4.167 4.167 0 0 0-1.821-1.82C15.167 2.5 14 2.5 11.667 2.5H8.334c-2.334 0-3.5 0-4.392.454a4.167 4.167 0 0 0-1.82 1.821c-.455.891-.455 2.058-.455 4.392v1.666c0 2.334 0 3.5.454 4.392a4.167 4.167 0 0 0 1.821 1.82c.65.332 1.448.422 2.74.446M6.25 7.917a.833.833 0 1 1 0-1.667.833.833 0 0 1 0 1.667Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgInsertImage);
export default ForwardRef;